import styles from "../../styles/addReceipt.module.css";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";
import { useEffect, useState } from "react";
import { showAlertFavor, showAlertErrorMonto } from "./Alerts";

/* const alert = showAlertErrorMonto();
      alert.fire();
       */
export function InvoiceCxc({
  inv,
  updateAbono,
  updateChecked,
  remainingMonto,
}) {
  const [displayValue, setDisplayValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setDisplayValue(inv.abono === 0 ? "" : formatCurrency(inv.abono));
    }
  }, [inv.abono, isEditing]);
  return (
    <tr>
      <td>
        <input
          type="checkbox"
          checked={inv.checked}
          onChange={(e) => updateChecked(inv.id, e.target.checked)}
        />
      </td>
      <td>{inv.factura?.numero_factura ?? "—"}</td>
      <td>{inv.factura.cuenta_ingreso?.nombre ?? "—"}</td>
      <td className={styles.saldo}>₡{formatCurrency(inv.saldo)}</td>
      <td>
        <input
          type="text"
          className={styles["input-abono"]}
          value={displayValue}
          disabled={!inv.checked}
          placeholder="0,00"
          onFocus={() => {
            setIsEditing(true);
            setDisplayValue(
              inv.abono ? inv.abono.toString().replace(".", ",") : "",
            );
          }}
          onChange={(e) => {
            if (inv.negative === false) {
              console.log("here");
              let raw = e.target.value.replace(/[^0-9,]/g, "");

              const parts = raw.split(",");
              if (parts.length > 2) return;
              if (parts[1]?.length > 2) return;

              let num = Number(raw.replace(",", ".")) || 0;

              const maxAllowed = Math.min(
                Number(inv.monto),
                remainingMonto + (inv.abono || 0),
              );

              if (num > maxAllowed) {
                /* num = maxAllowed; // ! ERROR */
                const alert = showAlertFavor(num - maxAllowed);
                alert.fire();
                /* raw = maxAllowed.toString().replace(".", ","); */
                raw = Math.max(
                  Number(inv.monto),
                  remainingMonto + (inv.abono || 0),
                );
              }

              setDisplayValue(raw);
              updateAbono(inv.id, num);
              return;
            }
            let raw = e.target.value.replace(/[^0-9.-]/g, "");

            if (raw.includes("-") && raw.indexOf("-") !== 0) return;
            if ((raw.match(/\./g) || []).length > 1) return;
            if (raw === "" || raw === "-") {
              setDisplayValue(raw);
              return;
            }

            let num = Number(raw);

            // CLAMP entre saldo y 0
            const min = Number(inv.saldo); // ej: -10000
            const max = 0;
            num = Math.min(max, Math.max(min, num));

            setDisplayValue(num.toString());
            updateAbono(inv.id, num);
          }}
          onBlur={() => {
            setIsEditing(false);
            setDisplayValue(inv.abono === 0 ? "" : formatCurrency(inv.abono));
          }}
        />
      </td>
    </tr>
  );
}
